import { DialogContent as DialogContentUI } from "@evergis/ui";
import styled from "styled-components";

export const DialogContent = styled(DialogContentUI)`
  padding-top: 1rem;
`;
